// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MSM4h","textarea":"styles_textarea__2AWUf"};